module.exports = __webpack_public_path__ + "static/media/emo_white.a81cbf02.png";